import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=62dc6e3c&scoped=true&style=position%3A%20relative%3B&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=62dc6e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc6e3c",
  null
  
)

export default component.exports